import { warehouseApis } from '@apis/dashboard/warehouseApis';
import { useMutation } from '@hooks/useMutation';
import { WarehouseBase } from '@models/Warehouse';
import { useQueryClient } from '@tanstack/react-query';

export const usePostWarehouse = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: WarehouseBase) => {
      const response = await warehouseApis.post('/dashboard/warehouse/', {
        body,
      });
      return response[201];
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`/dashboard/warehouse/`]);
      },
    },
  );
};
